import React from 'react';

import Box from '@quintoandar/cozy-core/Box';
import Button from '@quintoandar/cozy-core/Button';
import Typography from '@quintoandar/cozy-core/Typography';

import SecondaryPageAppBar from 'components/SecondaryPageAppBar/SecondaryPageAppBar';
import ROUTES from 'routes/constants';

const title = {
  id: 'app.containers.ContactUs.title',
  defaultMessage: 'Ajuda',
};

const goToAgenda = () => {
  window.location.assign(ROUTES.AGENDA);
};

const openRentHelp = () => {
  window.location.assign(ROUTES.RENT_HELP);
};

const openSaleHelp = () => {
  window.location.assign(ROUTES.SALE_HELP);
};

const ContactUs = () => (
  <React.Fragment>
    <SecondaryPageAppBar
      title={title}
      showSearchButton={false}
      onArrowBackButtonClick={goToAgenda}
    />
    <Box maxWidth={480} mx="auto" p={3}>
      <Typography level="title" mb={2}>
        Fale com o suporte
      </Typography>
      <Typography level="body" kind="lighter" mb={3}>
        Escolha o atendimento mais adequado para continuar dentro do APP2.
      </Typography>
      <Box display="grid" gridGap={16}>
        <Button fullWidth onClick={openRentHelp}>
          Aluguel
        </Button>
        <Button fullWidth variant="secondary" onClick={openSaleHelp}>
          Compra e venda
        </Button>
      </Box>
    </Box>
  </React.Fragment>
);

export default ContactUs;
